<pp-modal
  [ppWidth]="currentStep === EEditAccountUserStep.SHARES_LIST ? 'auto' : '626px'"
  [ppScrollOnDefault]="true"
  [ppNoPadding]="true"
  >
  <ng-container heading>
    {{
    (currentStep === EEditAccountUserStep.CUSTOM_FIELDS_EDIT
    ? 'user_management_bulk_changes_define_permissions'
    : 'downgrade_account_admin_header'
    ) | ppTranslate: { siteName: customFieldsWorkspaceName }
    }}
  </ng-container>

  @if (!processing) {
    <ng-container body>
      @if (currentStep === EEditAccountUserStep.SELECT_SITES) {
        <pp-account-user-modal-site-list
          [ppAccount]="account"
          [ppEmailsReadOnly]="true"
          (ppSelectedWorkspacesChange)="setIsNextStepButtonDisabled()"
        ></pp-account-user-modal-site-list>
      }
      @if (currentStep === EEditAccountUserStep.SHARES_LIST) {
        <pp-account-user-modal-shares-list
          [ppAccount]="account"
          [ppShowingError]="showingError"
          (ppGoBack)="previousStep()"
          (ppShowCustomFieldsTable)="goToCustomFieldsEditStep($event)"
          [ppEmailsReadOnly]="true"
        ></pp-account-user-modal-shares-list>
      }
      @if (currentStep === EEditAccountUserStep.CUSTOM_FIELDS_EDIT) {
        <pp-account-user-modal-custom-fields
          [ppWorkspaceId]="customFieldsWorkspaceId"
        ></pp-account-user-modal-custom-fields>
      }
    </ng-container>
  }

  <ng-container footer>
    <pp-modal-generic-footer
      [ppConfirmText]="nextStepButtonText"
      [ppProcess]="processing || savingShare"
      (ppCancel)="previousStep()"
      (ppConfirm)="nextStep()"
      [ppDisabled]="isNextStepButtonDisabled"
    ></pp-modal-generic-footer>
  </ng-container>
</pp-modal>
